import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useChooseStepTopics(stepId) {
  const [topics, setTopics] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.steps.chooseTopics(stepId))
      .then((response) => {
        setTopics(response.data.data);
      });
  }, [stepId]);

  return topics;
}
